import { AvailableForBooking, OfferedService, Psychologist } from "utils/interfaces"
import { SlotType } from "utils/interfaces/psychologist"

export function isBookingAvailable(
    psy: Psychologist,
    slotTypes: SlotType[] = [SlotType.Online, SlotType.InPerson]
): boolean {
    return slotTypes.some(
        (slotType) => psy.offered_services.length > 0 && psy.available_for_booking[slotType]
    )
}

export function isFreeBookingAvailable(psy: Psychologist) {
    return isBookingAvailable(psy, [SlotType.Free])
}

export function isServiceHasSlots(
    service: OfferedService,
    availableDict: AvailableForBooking,
    onlyFree = false
): boolean {
    if (onlyFree && service.price === 0) return !!availableDict.free
    return !!(service.online ? availableDict.online : availableDict.in_person)
}
